import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import userManager from '../userManager';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
});

class IniDesconexion extends Component {

    componentDidMount = () => {
        userManager.signoutRedirect();
    }

    render() {
        return (<div></div>);
    };

};

IniDesconexion.propTypes = {
    user: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(IniDesconexion));